export const CHART_ACCOUNTS_REFRESH_EVENT = 'comptabilite:chart-accounts-refresh';

/** Build select options from live chart-of-accounts rows (Plan Comptable / getChartOfAccounts). */
export function buildChartAccountOptions(accounts = []) {
  const seen = new Set();
  const options = [];
  for (const row of accounts) {
    const num = String(row.account_number || row.code || row.numero_compte || '').trim();
    if (!num || seen.has(num)) continue;
    seen.add(num);
    const name = String(row.account_name || row.name || row.libelle || row.libelle_compte || '').trim();
    options.push({
      value: num,
      label: name ? `${num} — ${name}` : num,
    });
  }
  return options.sort((a, b) => a.value.localeCompare(b.value, undefined, { numeric: true }));
}

export function dispatchChartAccountsRefresh() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CHART_ACCOUNTS_REFRESH_EVENT));
  }
}
